import 'Shared/mootools';
import 'shared-constants';
import 'Shared/global';
import 'Shared/PopupModal';
import 'Shared/ifixit-header-footer';
import 'Shared/toaster';
import Loader from 'Shared/utils/loader';

// Initialize navigation event listeners
Loader.initNavEvents();
